import { render, staticRenderFns } from "./PrjTask.vue?vue&type=template&id=5d343017&"
import script from "./PrjTask.vue?vue&type=script&lang=ts&"
export * from "./PrjTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports